import { unknown } from 'zod';
import { useLocationStore } from '../state/storeLocation';
import { useTuneStore } from '../state/storeTunePrayer';

export const useCalenderSettings = () => {
	const imsak = useTuneStore( ( state ) => state.Imsak );
	const fajr = useTuneStore( ( state ) => state.Fajr );
	const sunrise = useTuneStore( ( state ) => state.Sunrise );
	const dhuhr = useTuneStore( ( state ) => state.Dhuhr );
	const asr = useTuneStore( ( state ) => state.Asr );
	const maghrib = useTuneStore( ( state ) => state.Maghrib );
	const sunset = useTuneStore( ( state ) => state.Sunset );
	const isha = useTuneStore( ( state ) => state.Isha );
	const midnight = useTuneStore( ( state ) => state.Midnight );
	const mfc = useLocationStore( ( state ) => state.mfc);
	const oaac = useLocationStore( ( state ) => state.oaac );
	const mncm = useLocationStore( ( state ) => state.mncm );
	const hlm = useLocationStore( ( state ) => state.hlm );
	const settingsPrayer = async ( prayerTime: { adjust: (arg0: { fajr: string | number | undefined; dhuhr: string | number | undefined; maghrib: string | number | undefined; isha: string | number | undefined; asr: string | undefined; midnight: string | undefined; highLats: string | undefined; }) => void; setMethod: (arg0: string | undefined) => void; tune: (arg0: { imsak: string; fajr: string; sunrise: string; dhuhr: string; asr: string; sunset: string; maghrib: string; isha: string; midnight: string; }) => void; } ) => {
		prayerTime.setMethod( mfc.method || 'MWL' );

		prayerTime.adjust( {
			fajr: mfc.params?.Fajr,
			dhuhr: `${dhuhr} min`,
			asr: oaac.method,
			maghrib: `${maghrib} min`,
			isha: mfc.params?.Isha,
			midnight: mncm.method,
			highLats: hlm.method,
		} );
		prayerTime.tune( {
			imsak,
			fajr,
			sunrise,
			dhuhr,
			asr,
			sunset,
			maghrib,
			isha,
			midnight,
		} );
	};

	return { settingsPrayer };
};
